import { BillDetails, ReconciliationModal } from 'entities/bill/ui';
import { useRef } from 'react';
import { Drawer } from 'antd';
import { useBill } from 'entities/bill/model';
import useToggle from 'shared/hooks/useToggle';

export const BillDetailsSlideOver = ({ show, onPayBill, bill, onClose }) => {
  const bottomRef = useRef(null);
  const { isPending, isFetching } = useBill(bill?._id);
  const [reconciliationModalOpened, toggleReconciliationModal] =
    useToggle(false);

  return (
    <>
      <Drawer
        closable
        destroyOnClose
        width={540}
        zIndex={10}
        title={'Bill Details'}
        placement="right"
        open={show}
        loading={isPending || isFetching}
        onClose={onClose}>
        {bill?._id && (
          <BillDetails
            onReconciliationModalOpen={() => {
              toggleReconciliationModal();
            }}
            onPayBill={onPayBill}
            id={bill._id}
            ref={bottomRef}
            onClose={onClose}
          />
        )}
      </Drawer>

      {bill && (
        <ReconciliationModal
          bill={bill}
          modalOpened={reconciliationModalOpened}
          handleClose={toggleReconciliationModal}
        />
      )}
    </>
  );
};
